import PropTypes from 'prop-types'

export default function NavbarListElement({ toolbar, children, className }) {
  return (
    <li
      className={`${className}
      tw-p-0 tw-relative tw-z-10`}>
      {children}
    </li>
  )
}

NavbarListElement.propTypes = {
  toolbar: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
}
